/* eslint-disable @typescript-eslint/no-var-requires */
import * as Sentry from '@sentry/react';

const ics = require('ics');
const moment = require('moment');
require('moment-timezone');

const renderTitle = (classData) => {
    if (!classData) return 'N/A';

    if (classData.isEvent) return classData.note;

    if (classData.isOfficeHour) return 'Office Hours';

    if (classData.section)
        return `${classData.course.subject} ${classData.course.courseNumber} (${classData.section.classType})`;

    if (classData.sections && Array.isArray(classData.sections))
        return `${classData.course.subject} ${classData.course.courseNumber} (${classData.sections[0].classType})`;

    return `${classData.course.subject} ${classData.course.courseNumber}`;
};

const renderInstructors = (classData) => {
    let instructorStr = '';

    if (!classData.instructors) return 'N/A';

    if (!Array.isArray(classData.instructors)) return 'N/A';

    if (classData.instructors.length === 0) return 'N/A';

    classData.instructors.forEach((ins) => {
        const instructorFullName = ins.firstName + ' ' + ins.lastName;
        instructorStr = instructorStr + instructorFullName + ' ';
    });

    return instructorStr;
};

const renderDescription = (classData) => {
    let description = '';

    if (classData.section) {
        description += `CRN: ${classData.section.crn.toString()}` + '\n';
    }

    if (classData.sections && Array.isArray(classData.sections) && classData.sections.length > 0) {
        description += `Type: ${classData.sections[0].classType}` + '\n';
        const crns = classData.sections.map((sc) => sc.crn);
        description += `CRN(s): ${crns.map(String)}` + '\n';
    }

    if (classData.instructors) {
        description = description + `Instructor(s): ${renderInstructors(classData)}`;
    }

    if (classData.sets && Array.isArray(classData.sets) && classData.sets.length > 0) {
        const sets = classData.sets.map((s) => s.displayCode);
        description = description + `Set(s): ${sets.map(String)}`;
    }

    return description;
};

const generateICalFile = (timetable: any) => {
    const { timetablesByWeek } = timetable;

    const events: any = [];

    Object.keys(timetablesByWeek).map((key, i) => {
        timetablesByWeek[key].map((o, j) => {
            const m = moment.tz(o.date, 'YYYY-MM-DDTHH:mm:ss', 'America/Vancouver');
            const date = m.utc();

            const day = date.format('D');
            const month = date.format('MM');
            const year = date.format('YYYY');

            const timeIn = moment(o.timeIn, 'HH:mm:ss');
            const timeOut = moment(o.timeOut, 'HH:mm:ss');

            const hour = timeIn.format('HH');
            const minute = timeIn.format('mm');
            const duration = timeOut.diff(timeIn, 'minutes');

            return events.push({
                uid: o.isOfficeHour
                    ? `Office_Hours_${i}_${j}`
                    : `${o.course.subject}_${o.course.courseNumber}_${i}_${j}`,
                title: renderTitle(o),
                location: o.buildingCode && o.room ? `${o.buildingCode}-${o.room.roomNumber}` : ``,
                start: [parseInt(year), parseInt(month), parseInt(day), parseInt(hour), parseInt(minute)],
                duration: { minutes: parseInt(duration) },
                startType: 'utc',
                description: renderDescription(o)
            });
        });
    });

    const { error, value } = ics.createEvents(events);

    if (error) {
        Sentry.captureException(error, (scope) => {
            scope.setContext('timetable', timetable);
            return scope;
        });
        return;
    }

    return window.open('data:text/calendar;charset=utf8,' + escape(value));
};

export default generateICalFile;
